(() => {
  const root = document.getElementById('dtf-builder-root');
  const data = document.getElementById('builder-config');
  if (!root || !data) return;
  const config = JSON.parse(data.textContent);
  window.DTF_BUILDER_CONFIG = config;
  if(new URLSearchParams(location.search).get('reorder')==='1'){
    import(config.reorderModuleUrl).then(module=>module.openReorder(root,config)).catch(fail);
    return;
  }
  function fail() {
    if (root.querySelector('.builder-app-wrapper')) return;
    root.replaceChildren(document.getElementById('builder-failure').content.cloneNode(true));
    root.querySelector('[data-builder-reload]').addEventListener('click', () => location.reload());
  }
  const script = document.createElement('script');
  script.src = config.bundleUrl;
  script.onload = () => setTimeout(fail, 300);
  script.onerror = fail;
  document.head.appendChild(script);
  setTimeout(fail, 15000);
})();
